import { useContext, useEffect, useRef } from "react";
import { Typography, Button } from "@mui/material";
import { useDrop } from "react-dnd";
import { DraggableQuestion } from "../DraggableQuestion"; // Reusable DraggableQuestion component
import ProfileQuestionContext from "../../../../contexts/ProfileQuestionContext";
import request from "../../../../utilities/requests";
import { toast } from "../../../../utilities/SnackBarUtils";

const WorkSpace = ({ refresh }) => {
  const {
    setQuestions,
    questionGroup,
    setQuestionGroup,
    questionGroupQuestions,
    setQuestionGroupQuestions,
    questionGroupMessage,
    setQuestionGroupMessage,
  } = useContext(ProfileQuestionContext); // Access setQuestions from the context
  const questionGroupRef = useRef(questionGroup);

  // Update the ref whenever questionGroup changes
  useEffect(() => {
    questionGroupRef.current = questionGroup;
  }, [questionGroup]);

  const updateQuestionGroup = async (item) => {
    const body = {
      questionGroupId: questionGroupRef.current,
      add: [item._id],
    };
    const result = await request("questiongroups/update", "post", body);
    if (result.success) {
      if (result.message) {
        setQuestionGroupMessage(result.message);
      } else  {
        setQuestionGroupMessage('')
      }
    }
  };

  // Define the drop target behavior for the WorkSpace
  const [{ isOver }, dropRef] = useDrop(() => ({
    accept: "QUESTION",
    drop: (item, monitor) => {
      setQuestionGroupQuestions((prevQuestions) => {
        // Avoid duplicates
        if (prevQuestions.some((q) => q._id === item._id)) return prevQuestions;
        return [...prevQuestions, { _id: item._id, question: item.question }];
      });
      setQuestions((prev) => prev.filter((q) => q._id !== item._id));
      updateQuestionGroup(item);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  const handleDelete = async () => {
    const body = { questionGroupId: questionGroup };
    const result = await request("questiongroups/delete", "post", body);
    if (result.success && result.deleted === false) {
      toast.error(result.message);
      return;
    } else if (result.success) {
      toast.success("Question group deleted successfully!");
      setQuestionGroup(null);
      refresh();
    }
  };

  if (!questionGroup) {
    return (
      <div
        style={{
          height: "100%",
          padding: 10,
          border: "1px solid black",
          backgroundColor: isOver ? "lightgreen" : "white",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: 30,
            padding: 20,
          }}
        >
          <Typography>
            Please select a Question Group from the dropdown above or create a
            new one
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={dropRef}
      style={{
        height: "100%",
        padding: 10,
        border: "1px solid black",
        backgroundColor: isOver ? "lightgreen" : "white",
        overflow: "auto",
      }}
    >
      {questionGroupMessage ? (
        <div style={{padding: 20}}>
        <Typography style={{color: 'red'}}>{questionGroupMessage}</Typography>
        </div>
      ) : (
        <></>
      )}
      {questionGroupQuestions.map((question) => (
        <DraggableQuestion
          key={question._id}
          question={question}
          questionGroupId={questionGroup}
          // No need to manually handle onDropOut; it's handled by `useDrop`
        />
      ))}
      {questionGroupQuestions.length === 0 ? (
        <Button
          variant="outlined"
          style={{
            color: "red",
            border: "solid 1px red",
            marginTop: 20,
            width: "100%",
          }}
          onClick={handleDelete}
        >
          Delete question group
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default WorkSpace;
